import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const PromptContainer = styled.div`
    position: fixed;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    background-color: rgba(255, 255, 255, 0.9);
    padding: 15px 20px;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
    display: ${props => props.$show ? 'flex' : 'none'};
    flex-direction: column;
    align-items: center;
    max-width: 90%;
    z-index: 1000;
`;

const Title = styled.h3`
  margin: 0 0 10px 0;
  font-size: 18px;
`;

const Description = styled.p`
  margin: 0 0 15px 0;
  text-align: center;
  font-size: 14px;
`;

const Button = styled.button`
  background-color: #4CAF50;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  font-weight: bold;
  cursor: pointer;
  
  &:hover {
    background-color: #45a049;
  }
`;

const CloseButton = styled.button`
  position: absolute;
  top: 5px;
  right: 5px;
  background: none;
  border: none;
  font-size: 16px;
  cursor: pointer;
`;

const InstallPrompt = () => {
    const [showPrompt, setShowPrompt] = useState(false);
    const [deferredPrompt, setDeferredPrompt] = useState(null);

    useEffect(() => {
        const handleBeforeInstallPrompt = (e) => {
            // Prevent the mini-infobar from appearing on mobile
            e.preventDefault();
            // Stash the event so it can be triggered later
            setDeferredPrompt(e);
            // Show our custom install prompt
            setShowPrompt(true);
        };

        window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

        return () => {
            window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
        };
    }, []);

    const handleInstallClick = () => {
        // Hide the prompt
        setShowPrompt(false);

        // Show the install prompt
        if (deferredPrompt) {
            deferredPrompt.prompt();

            // Wait for the user to respond to the prompt
            deferredPrompt.userChoice.then((choiceResult) => {
                if (choiceResult.outcome === 'accepted') {
                    console.log('User accepted the install prompt');
                } else {
                    console.log('User dismissed the install prompt');
                }
                // Clear the deferredPrompt
                setDeferredPrompt(null);
            });
        }
    };

    const handleCloseClick = () => {
        setShowPrompt(false);
    };

    return (
        <PromptContainer $show={showPrompt}>
            <CloseButton onClick={handleCloseClick}>✕</CloseButton>
            <Title>Install Be-a-Veg</Title>
            <Description>
                Install this app on your device for the full vegetable experience.
            </Description>
            <Button onClick={handleInstallClick}>Install</Button>
        </PromptContainer>
    );
};

export default InstallPrompt;
